<div>
  <setup-header></setup-header>
  <div class="main">
    <div id="sidemenu" [ngClass]="toggledSidemenu ? 'active' : ''" class="setup-nav">
      <span (click)="toggleSidemenu()">
        <a class="sidemenu-collapse sap-icon" title="{{'MainMenu.ToggleMenu' | translate}}">&#xe1c5;</a>
      </span>
      <div class="sidemenu-wrapper" [ngClass]="toggledSidemenu ? 'hidden' : ''">
        <menu-nav-bar></menu-nav-bar>
      </div>
    </div>
    <div class="setup-content cpq-scroll">
      <div class="top">
        <div class="current">
          <h2>{{ currentPage }}</h2>
          @if (warningMsg) {
            <span class="alert alert-warning" style="display:inline-block">
              <span class="sap-icon">&#xe201;</span>
              {{ warningMsg }}
            </span>
          }
        </div>
      </div>
      <div class="frame">
        <router-outlet></router-outlet>
      </div>
      <div class="footer">
        <setup-footer></setup-footer>
      </div>
    </div>
  </div>